import { FunctionalComponent, h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { ANCHORS } from '../mock/data';
import type { Anchor } from '../mock/types';
import '../style.css';

interface Props {
  open: boolean;
  /** 主播列表（接口模式传 fetchAnchors 结果，与主页一致；缺省用静态样例） */
  anchors?: Anchor[];
  /** 当前生效主播 id（all 时也可标注） */
  currentAnchorId: number;
  onCancel: () => void;
  onPick: (a: Anchor) => void;
}

/** 搜索主播选择弹层（P01/P02）：只改搜索所属主播；列加载失败可局部重试（静态演示开关） */
const HostPickerModal: FunctionalComponent<Props> = ({ open, anchors, currentAnchorId, onCancel, onPick }) => {
  const [failed, setFailed] = useState(false);
  const list = anchors && anchors.length ? anchors : ANCHORS;

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onCancel]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  return (
    <div>
      <div class="vp-mask" onClick={onCancel} />
      <div class="vp-sheet" role="dialog" aria-label="选择搜索主播">
        <div class="vp-sheet-head">
          <b class="vp-sheet-title">选择搜索主播</b>
          <button class="vp-sheet-close" onClick={onCancel} aria-label="关闭">×</button>
        </div>

        {failed ? (
          <div class="vp-picker-failed">
            <p>主播列表加载失败，请重试</p>
            <button class="vp-card-btn solid" onClick={() => setFailed(false)}>重新加载</button>
          </div>
        ) : (
          <div class="vp-picker-list">
            {list.map((a) => (
              <button
                key={a.id}
                class={`vp-picker-item${a.id === currentAnchorId ? ' on' : ''}`}
                onClick={() => onPick(a)}
              >
                <i class="vp-avatar">{a.name.slice(0, 1)}</i>
                <span class="vp-picker-name">{a.name}</span>
                <span class="vp-picker-tags">{a.tags}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HostPickerModal;
